import type { ComponentType, SVGProps } from 'react';
import type { Rol } from '@eventos-cien/shared';
import { IconEventos, IconTicket, IconUsuarios } from './icons';

export interface DestinoNav {
  to: string;
  etiqueta: string;
  /** Basta con tener uno de estos roles para ver el destino. */
  roles: Rol[];
  Icono: ComponentType<SVGProps<SVGSVGElement>>;
  /** NavLink `end`: evita que quede activo en sub-rutas (p. ej. /admin/usuarios). */
  fin?: boolean;
}

export const DESTINOS_NAV: DestinoNav[] = [
  { to: '/admin', etiqueta: 'Eventos', roles: ['admin'], Icono: IconEventos, fin: true },
  { to: '/admin/usuarios', etiqueta: 'Usuarios', roles: ['admin'], Icono: IconUsuarios },
  { to: '/panel', etiqueta: 'Mi panel', roles: ['asesor', 'staff'], Icono: IconTicket },
];
